// src/App.js
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import config from "../config/config";
import "./App.scss";
import AppRoutes from "./AppRoutes";
import Navbar from "./shared/Navbar";
import Sidebar from "./shared/Sidebar";

// your existing App component
function App({ location }) {
  const userInfo = useSelector((state) => state.auth);

  useEffect(() => {
    onRouteChanged();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const onRouteChanged = () => {
    window.scrollTo(0, 0);
    const fullPageLayoutRoutes = [
      "/user-pages/login-1",
      "/user-pages/login-2",
      // …etc…
    ];
    const wrapper = document.querySelector(".page-body-wrapper");
    if (fullPageLayoutRoutes.includes(location.pathname)) {
      wrapper.classList.add("full-page-wrapper");
    } else {
      wrapper.classList.remove("full-page-wrapper");
    }
  };

  const navbarComponent = userInfo?.user ? <Navbar /> : null;
  const sidebarComponent = userInfo?.user ? <Sidebar /> : null;

  return (
    <div className="light container-scroller">
      {sidebarComponent}
      <div className="container-fluid page-body-wrapper">
        {navbarComponent}
        <div className="main-panel">
          <div className="content-wrapper">
            <AppRoutes isAuthenticated={userInfo.isLoggedIn} />
          </div>
        </div>
      </div>
    </div>
  );
}

// wrap App in the GoogleOAuthProvider
function AppWithGoogleProvider(props) {
  return (
    <GoogleOAuthProvider clientId={config.GOOGLE_CLIENT_ID}>
      <App {...props} />
    </GoogleOAuthProvider>
  );
}

export default withRouter(AppWithGoogleProvider);